// extracted by mini-css-extract-plugin
module.exports = {"item":"ChronologyDateItem_item__u_rkZ","content":"ChronologyDateItem_content__lKkqd","timeline":"ChronologyDateItem_timeline__Rmv8_","dot":"ChronologyDateItem_dot__FqYGQ"};